import React from 'react'
import { Col, Container, Row } from 'react-bootstrap';

import './road_styles/roadhead.css';

export default function RoadHead() {
  return (
    <>
      <Container fluid className='roadhead mb-5'>
        <Row>
          <Col>
            <h2>Roadmap</h2>
          </Col>  
        </Row>
      </Container>
    </>
  )
}
